/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import {
  setCookies,
  getCookiesJSON,
  getCookies,
  removeCookies,
} from './index';


export function setAuthCookies(auth) {
  if (!auth) {
    return;
  }
  const expires = auth.expires_in;
  let options;
  if (expires) {
    options = {
      expires: expires / 86400,
    };
  }
  setCookies('auth', auth, options);
  // backward compatible with legacy api calls
  setCookies('token', auth.access_token, options);
}

export function getAuthCookies() {
  return getCookiesJSON('auth');
}

export function getTokenCookies() {
  return getCookies('token');
}

export function removeAuthCookies() {
  removeCookies('auth');
  // backward compatible with legacy api calls
  removeCookies('token');
}




// WEBPACK FOOTER //
// ./src/utils/cookies/auth.js